import React, { useMemo } from "react";
import WaveImg from "../../Assets/Main/Utils/wave.png";
import { useSelector } from "react-redux";

const GreetingText = () => {
  const { isAuthenticated, admin, payment_executive } = useSelector(
    (state) => state.admin
  );

  const userName = useMemo(() => {
    return isAuthenticated && admin?.data?.name
      ? admin?.data.name
      : payment_executive?.data?.name || "James";
  }, [isAuthenticated, admin, payment_executive]);

  const currentHour = useMemo(() => new Date().getHours(), []);

  const greeting = useMemo(() => {
    if (currentHour < 12) {
      return "Good Morning ";
    } else if (currentHour >= 12 && currentHour < 17) {
      return "Good Afternoon ";
    } else {
      return "Good Evening ";
    }
  }, [currentHour]);

  return (
    <div className="greeting-text">
      <p className="font-Regular">
        <span className="flex-container flex-row items-center">
          {greeting}
          <span className="flex-container">
            <img src={WaveImg} alt="wave-emoji" />
          </span>
        </span>
        <span className="font-ExtraBold">{userName}</span>
      </p>
    </div>
  );
};

export default GreetingText;
